import React from 'react';
import {
  CARD_SUBVALUE_BASE,
  CARD_VALUE_BASE,
  cardSubValueClass,
  cardValueClass,
  type CardValueScale,
} from '../../lib/responsiveCardValue';

type ResponsiveCardValueProps = {
  value: string;
  scale?: CardValueScale;
  className?: string;
  subValue?: string;
  subClassName?: string;
  /** Extra wrapper classes on the value line (e.g. text-emerald-700). */
  valueClassName?: string;
};

export function ResponsiveCardValue({
  value,
  scale = 'default',
  className = '',
  subValue,
  subClassName = '',
  valueClassName = '',
}: ResponsiveCardValueProps) {
  return (
    <>
      <p className={`${CARD_VALUE_BASE} ${cardValueClass(value, scale)} ${valueClassName} ${className}`.trim()}>
        {value}
      </p>
      {subValue ? (
        <p className={`mt-0.5 ${CARD_SUBVALUE_BASE} ${cardSubValueClass(subValue)} ${subClassName}`.trim()}>
          {subValue}
        </p>
      ) : null}
    </>
  );
}

/** Single-line metric inside app-card / stat tiles. */
export function CardMetric({
  value,
  scale = 'default',
  className = 'mt-2',
}: {
  value: string;
  scale?: CardValueScale;
  className?: string;
}) {
  return <p className={`${CARD_VALUE_BASE} ${cardValueClass(value, scale)} ${className}`.trim()}>{value}</p>;
}
